/** Sum per-device day rows for a shared table checklist subset. */

export interface DeviceDayUptime {
  deviceId: string;
  day: string;
  uptimeHours: number;
  capacityHours: number;
  unmeasuredHours: number;
}

export function selectedDayUptime(
  rows: readonly DeviceDayUptime[],
  selected: ReadonlySet<string>,
  day: string,
): {
  uptimeHours: number;
  capacityHours: number;
  unmeasuredHours: number;
  anyUnmeasured: boolean;
} {
  let uptimeHours = 0;
  let capacityHours = 0;
  let unmeasuredHours = 0;
  let anyUnmeasured = false;
  for (const row of rows) {
    if (row.day !== day || !selected.has(row.deviceId)) continue;
    uptimeHours += row.uptimeHours;
    capacityHours += row.capacityHours;
    unmeasuredHours += row.unmeasuredHours;
    if (row.unmeasuredHours > 0) anyUnmeasured = true;
  }
  return { uptimeHours, capacityHours, unmeasuredHours, anyUnmeasured };
}

export function sumDeviceDayCount(
  rows: readonly { deviceId: string; day: string; count: number }[],
  selected: ReadonlySet<string>,
  day: string,
): number {
  let sum = 0;
  for (const row of rows) {
    if (row.day === day && selected.has(row.deviceId)) sum += row.count;
  }
  return sum;
}
